"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgExclamationTriangle = function SvgExclamationTriangle(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M466.5 318.5c-1.2-25.1 18.2-46.4 43.3-47.6 25.1-1.2 46.4 18.2 47.6 43.3.1 1.4.1 2.8 0 4.3v316.4c0 25.1-20.3 45.4-45.4 45.5-25.1 0-45.5-20.4-45.5-45.5V318.5zm557.4 574.7c0 72.2-58.6 130.8-130.8 130.8H130.9c-20.3 0-40.3-4.7-58.5-13.8-64.6-32.3-90.8-110.9-58.5-175.5L395 72.3C417 27.9 462.4-.2 512 0c49.6-.2 95 27.9 117 72.3l381.1 762.4c9.1 18.2 13.8 38.2 13.8 58.5zm-90.1-20.3L552.7 110.4c-7.6-15.5-23.4-25.3-40.7-25.1-17.3-.1-33.1 9.7-40.7 25.2L90.2 872.9c-15.1 30.2 6.9 65.8 40.7 65.8h762.2c33.8 0 55.8-35.6 40.7-65.8zM512 740c-34.2 0-62 27.8-62 62s27.8 62 62 62 62-27.8 62-62-27.8-62-62-62z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgExclamationTriangle, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;